import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { useStore } from "../../../../../../models";
import { ChipTag } from "../../../../../chip/presets/ChipTag/ChipTag";
import { TagPicker } from "../../../../../forms/tagPicker/tagPicker";
import { Tag } from "../../../../proactiveMessages/types";
import styles from "../../taggingSettings.css";

interface Props {
  isEdited: boolean;
  form: Tag;
}
export const FormTag = observer(({ form, isEdited }: Props) => {
  const { tagsStore } = useStore();
  const renderFormTagLabel = () => {
    return (
      <div className={classNames(styles["form-text"], styles["form-text-dimmed"])}>
        <L10n id={"settings.tagging.mapping.tag"} />
      </div>
    );
  };

  const renderFormTag = () => {
    const { id, tag, enabled } = form.$;

    if (isEdited) {
      return (
        <div className={styles["bottom-input"]}>
          <TagPicker
            tagId={id.$}
            onChange={(pickedTag) => {
              id.reset(pickedTag.id);
              tag.reset(pickedTag.name);
            }}
            values={tagsStore.orgTagsWithoutSystem}
          />
        </div>
      );
    }

    return (
      <div className={styles["bottom-input"]}>
        <ChipTag name={tag.$} enabled={enabled.$} />
      </div>
    );
  };

  return (
    <div className={classNames(styles["inputs-container"], styles["tag-input"])}>
      {renderFormTagLabel()}
      {renderFormTag()}
    </div>
  );
});
